<template>
  <div class="card">
    <div
      v-if="this.errosValidacaoGeral.length"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mx-9 mt-9 p-6"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            <ul>
              <li v-for="value in this.errosValidacaoGeral" :key="value">
                {{ value }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="card-header">
      <h3 class="card-title">
        <img src="media/icons/duotune/coding/cod007.svg" class="me-2" />Empresas
        Vinculadas
      </h3>
    </div>
    <div class="card-body p-0">
      <div class="card-header border-0 pt-5">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <input
              id="txtPesquisarEmpresasVinculadas"
              type="text"
              v-model="tableData.search"
              @input="onSearch($event.target.value)"
              class="form-control form-control-solid w-250px ps-15"
              placeholder="Pesquisar"
            />
          </div>
        </div>
        <div class="card-toolbar">
          <div
            v-if="checkedEmitenteSoftwareHouse.length === 0"
            class="d-flex justify-content-end"
            data-kt-customer-table-toolbar="base"
          >
            <button
              @click="this.$refs.table.exportarExcel()"
              type="button"
              class="btn btn-sm btn-light-primary me-3"
            >
              <span class="svg-icon svg-icon-2">
                <inline-svg src="media/icons/duotune/arrows/arr078.svg" />
              </span>
              Exportar
            </button>
            <button
              v-if="this.adicionar"
              type="button"
              class="btn btn-sm btn-light-info"
              @click="vincularEmpresa()"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg src="media/icons/duotune/coding/cod008.svg" /></span
              >Vincular Empresa
            </button>
          </div>
          <div
            v-else
            class="d-flex justify-content-end align-items-center"
            data-kt-customer-table-toolbar="selected"
          >
            <div class="fw-bolder me-5">
              <span class="me-2">{{ checkedEmitenteSoftwareHouse.length }}</span
              >Selecionado(s)
            </div>
            <button
              v-if="this.excluir"
              type="button"
              class="btn btn-sm btn-danger"
              @click="deleteSelecionados()"
            >
              Desvincular Selecionado(s)
            </button>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <Datatable
          ref="table"
          :table-header="tableHeader"
          :table-data="tableData"
          :table-pagination="tablePagination"
          :page-sizes="pageSizes"
          :enable-items-per-page-dropdown="true"
          :hide-on-single-page="false"
          empty-table-text="Nenhuma informação encontrada"
          v-on:checked-rows="checkedEmitenteSoftwareHouse = $event"
          :colors="true"
        >
          <template v-slot:cell-checkbox="{ row: emitenteSoftwareHouse }">
            <div
              class="form-check form-check-sm form-check-custom form-check-solid"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="emitenteSoftwareHouse.guid"
                v-model="checkedEmitenteSoftwareHouse"
              />
            </div>
          </template>
          <template v-slot:cell-id_empresa="{ row: emitenteSoftwareHouse }">
            <div class="text-center">
              {{ emitenteSoftwareHouse.id_empresa }}
            </div>
          </template>
          <template v-slot:cell-empresa_logo="{ row: emitenteSoftwareHouse }">
            <div
              v-if="
                emitenteSoftwareHouse.Emitente
                  ? emitenteSoftwareHouse.Emitente.logo
                  : ''
              "
              class="symbol symbol-50px"
            >
              <div
                class="symbol-label fs-2 fw-bold bg-light-dark"
                :style="{
                  'background-image': `url(${
                    this.$utils.getUrl() + emitenteSoftwareHouse.Emitente.logo
                  })`,
                }"
              ></div>
            </div>
            <div v-else class="symbol symbol-50px">
              <div
                :class="[
                  'symbol-label fs-2 fw-bold ' + emitenteSoftwareHouse.color,
                ]"
              >
                {{
                  emitenteSoftwareHouse.Emitente
                    ? emitenteSoftwareHouse.Emitente.nome
                        .substring(0, 1)
                        .toUpperCase()
                    : ""
                }}
              </div>
            </div>
          </template>
          <template v-slot:cell-empresa="{ row: emitenteSoftwareHouse }">
            <div class="align-middle min-w-200px">
              <div>
                <span class="text-dark fw-bolder text-hover-primary mb-1">
                  {{
                    emitenteSoftwareHouse.Emitente
                      ? emitenteSoftwareHouse.Emitente.nome
                      : ""
                  }}
                </span>
                <span class="text-muted fw-bold d-block fs-7">
                  {{
                    emitenteSoftwareHouse.Emitente
                      ? this.$utils.setMask(
                          emitenteSoftwareHouse.Emitente.cnpj,
                          "##.###.###/####-##",
                          true
                        )
                      : ""
                  }}
                </span>
              </div>
            </div>
          </template>
          <template
            v-slot:cell-id_software_house="{ row: emitenteSoftwareHouse }"
          >
            <div class="text-center">
              {{ emitenteSoftwareHouse.id_software_house }}
            </div>
          </template>
          <template
            v-slot:cell-software_house_logo="{ row: emitenteSoftwareHouse }"
          >
            <div
              v-if="
                emitenteSoftwareHouse.SoftwareHouse
                  ? emitenteSoftwareHouse.SoftwareHouse.logo
                  : ''
              "
              class="symbol symbol-50px"
            >
              <div
                class="symbol-label fs-2 fw-bold bg-light-dark"
                :style="{
                  'background-image': `url(${
                    this.$utils.getUrl() +
                    emitenteSoftwareHouse.SoftwareHouse.logo
                  })`,
                }"
              ></div>
            </div>
            <div v-else class="symbol symbol-50px">
              <div
                :class="[
                  'symbol-label fs-2 fw-bold ' + emitenteSoftwareHouse.color,
                ]"
              >
                {{
                  emitenteSoftwareHouse.SoftwareHouse
                    ? emitenteSoftwareHouse.SoftwareHouse.nome
                        .substring(0, 1)
                        .toUpperCase()
                    : ""
                }}
              </div>
            </div>
          </template>
          <template v-slot:cell-software_house="{ row: emitenteSoftwareHouse }">
            <div class="align-middle min-w-200px">
              <div>
                <span class="text-dark fw-bolder text-hover-primary mb-1">
                  {{
                    emitenteSoftwareHouse.SoftwareHouse
                      ? emitenteSoftwareHouse.SoftwareHouse.nome
                      : ""
                  }}
                </span>
                <span class="text-muted fw-bold d-block fs-7">
                  {{
                    emitenteSoftwareHouse.SoftwareHouse
                      ? this.$utils.setMask(
                          emitenteSoftwareHouse.SoftwareHouse.cnpj,
                          "##.###.###/####-##",
                          true
                        )
                      : ""
                  }}
                </span>
              </div>
            </div>
          </template>
          <template v-slot:cell-guid="{ row: emitenteSoftwareHouse }">
            <span class="badge badge-light-info">{{
              emitenteSoftwareHouse.guid
            }}</span>
          </template>
          <template v-slot:cell-bloqueado="{ row: emitenteSoftwareHouse }">
            <div
              class="form-check form-check-sm form-check-custom form-check-danger form-check-solid"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :checked="
                  this.$utils.stringToBoolean(emitenteSoftwareHouse.bloqueado)
                "
                disabled
              />
            </div>
          </template>
          <template v-slot:cell-acoes="{ row: emitenteSoftwareHouse }">
            <button
              class="btn btn-sm btn-light btn-active-light-primary py-2"
              data-kt-menu-trigger="click"
              data-kt-menu-placement="bottom-end"
              data-kt-menu-flip="top-end"
            >
              Ações
              <span class="svg-icon svg-icon-5 m-0">
                <inline-svg src="media/icons/duotune/arrows/arr072.svg" />
              </span>
            </button>
            <div
              v-if="this.editar || this.excluir"
              class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4"
              data-kt-menu="true"
            >
              <div v-if="this.editar" class="menu-item px-3">
                <a
                  @click="editarRegistro(emitenteSoftwareHouse.guid)"
                  class="menu-link px-3"
                  >Editar</a
                >
              </div>
              <div
                v-if="this.editar && emitenteSoftwareHouse.bloqueado === '1'"
                class="menu-item px-3"
              >
                <a
                  @click="atualizarRegistro(emitenteSoftwareHouse)"
                  class="menu-link px-3"
                  >Desbloquear</a
                >
              </div>
              <div
                v-if="this.editar && emitenteSoftwareHouse.bloqueado === '0'"
                class="menu-item px-3"
              >
                <a
                  @click="atualizarRegistro(emitenteSoftwareHouse)"
                  class="menu-link px-3"
                  >Bloquear</a
                >
              </div>
              <div v-if="this.excluir" class="menu-item px-3">
                <a
                  @click="removerRegistro(emitenteSoftwareHouse.guid)"
                  class="menu-link px-3"
                  >Desvincular</a
                >
              </div>
            </div>
          </template>
        </Datatable>
      </div>
    </div>
  </div>
  <EmitenteSoftwareHouseModal
    v-if="exibirEmitenteSoftwareHouse"
    :guidEmitenteSoftwareHouse="guidEmitenteSoftwareHouse"
    @exibirModalEmitenteSoftwareHouse="modalEmitenteSoftwareHouse"
    @atualizarEmitenteSoftwareHouse="this.$refs.table.load()"
  ></EmitenteSoftwareHouseModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import Datatable from "@/components/kt-datatable/KTDatatableCustom.vue";
import EmitenteSoftwareHouseModal from "../empresas/EmitenteSoftwareHouseModal.vue";
import { mapState } from "vuex";
import { useToast } from "vue-toastification";
const toast = useToast();
import { getOrCreateInstanceModal } from "@/core/helpers/dom";

export default {
  components: {
    Datatable,
    EmitenteSoftwareHouseModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    editarRegistro(guid) {
      this.guidEmitenteSoftwareHouse = guid;
      this.modalEmitenteSoftwareHouse(true);
    },
    async atualizarRegistro(emitenteSoftwareHouse) {
      if (emitenteSoftwareHouse.bloqueado === "1") {
        emitenteSoftwareHouse.bloqueado = "0";
      } else {
        emitenteSoftwareHouse.bloqueado = "1";
      }
      try {
        var ret = await this.$store.dispatch(
          "emitenteSoftwareHouse/putEmitenteSoftwareHouse",
          emitenteSoftwareHouse
        );
        if (ret.Success === true) {
          if (ret.Data.bloqueado === "1") {
            toast.success("Empresa bloqueada com sucesso!", {
              timeout: 3000,
            });
          } else {
            toast.success("Empresa desbloqueada com sucesso!", {
              timeout: 3000,
            });
          }
          this.$refs.table.load();
        }
      } catch (error) {
        await Swal.fire({
          text: error.Message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn fw-bold btn-danger",
          },
        });
      }
    },
    vincularEmpresa() {
      this.guidEmitenteSoftwareHouse = "";
      this.modalEmitenteSoftwareHouse(true);
    },
    modalEmitenteSoftwareHouse(exibir) {
      this.exibirEmitenteSoftwareHouse = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_emitente_softwarehouse_editar");
        }, 100);
      }
    },
    onSearch(pesquisa) {
      if (pesquisa !== "") {
        pesquisa = pesquisa.replace("'", "''");
        this.tableData.filterOData =
          "&$filter=contains(Emitente/nome, '" +
          pesquisa +
          "') or contains(Emitente/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') or contains(SoftwareHouse/nome, '" +
          pesquisa +
          "') or contains(SoftwareHouse/cnpj, '" +
          this.$utils.unMask(pesquisa) +
          "') ";
        if (this.$utils.isNumber(pesquisa)) {
          this.tableData.filterOData =
            this.tableData.filterOData +
            " or id_empresa eq " +
            pesquisa +
            " or id_software_house eq " +
            pesquisa;
        }
      } else {
        this.tableData.filterOData = "";
      }
    },
    async deleteSelecionados() {
      var alert = await Swal.fire({
        text: "Deseja remover os registros selecionados?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        for (var i = 0; i < this.checkedEmitenteSoftwareHouse.length; i++) {
          await this.excluirEmitenteSoftwareHouse(
            this.checkedEmitenteSoftwareHouse[i]
          );
        }
        if (this.excluiuCadastro === true) {
          toast.success("Registros excluídos com sucesso!", {
            timeout: 3000,
          });
        }
        this.$refs.table.load();
      }
    },
    async removerRegistro(id) {
      var alert = await Swal.fire({
        text: "Deseja remover o registro?",
        icon: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "Sim, remova!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn fw-bold btn-primary",
          cancelButton: "btn fw-bold btn-danger",
        },
      });
      if (alert.isConfirmed) {
        this.errosValidacaoGeral = [];
        this.excluiuCadastro = true;
        this.$refs.table.setLoading(true);
        await this.excluirEmitenteSoftwareHouse(id);
        if (this.excluiuCadastro === true) {
          toast.success("Registro excluído com sucesso!", {
            timeout: 3000,
          });
        }
        this.$refs.table.load();
      }
    },
    async excluirEmitenteSoftwareHouse(id) {
      try {
        await this.$store.dispatch(
          "emitenteSoftwareHouse/deleteEmitenteSoftwareHouse",
          id
        );
      } catch (error) {
        this.excluiuCadastro = false;
        this.errosValidacaoGeral.push(error.Message);
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    async verificarRestricoes() {
      if (this.user.User.TipoUsuario.Restricao != null) {
        this.user.User.TipoUsuario.Restricao.find((element) => {
          if (element.regra === "Permitir.EmitenteSoftwareHouse.Incluir") {
            this.adicionar = true;
          }
          if (element.regra === "Permitir.EmitenteSoftwareHouse.Alterar") {
            this.editar = true;
          }
          if (element.regra === "Permitir.EmitenteSoftwareHouse.Excluir") {
            this.excluir = true;
          }
        });
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    setTimeout(() => {
      this.nextFocus("txtPesquisarEmpresasVinculadas");
    }, 800);
  },
  data() {
    return {
      adicionar: false,
      editar: false,
      excluir: false,
      checkedEmitenteSoftwareHouse: [],
      guidEmitenteSoftwareHouse: "",
      exibirEmitenteSoftwareHouse: false,
      errosValidacaoGeral: [],
      excluiuCadastro: true,
      tableHeader: [
        {
          type: "checkbox",
          key: "checkbox",
          sortable: false,
          sortingField: "guid",
        },
        {
          name: "ID Empresa",
          key: "id_empresa",
          sortable: true,
        },
        {
          key: "empresa_logo",
          sortable: false,
        },
        {
          name: "Empresa",
          key: "empresa",
          sortable: true,
          sortingField: "Emitente/nome",
        },
        {
          name: "ID SoftwareHouse",
          key: "id_software_house",
          sortable: true,
        },
        {
          key: "software_house_logo",
          sortable: false,
        },
        {
          name: "SoftwareHouse",
          key: "software_house",
          sortable: true,
          sortingField: "SoftwareHouse/nome",
        },
        {
          name: "GUID",
          key: "guid",
          sortable: false,
        },
        {
          name: "Bloqueado",
          key: "bloqueado",
          sortable: false,
        },
        {
          name: "Ações",
          key: "acoes",
          sortable: false,
        },
      ],
      tableData: {
        store: "emitenteSoftwareHouse/getEmitenteSoftwareHouseOData",
        selectOData:
          "?$select=id_empresa,id_software_house,guid,bloqueado&$expand=Emitente($select=nome,cnpj,logo),SoftwareHouse($select=nome,cnpj,logo)",
        filterOData: "",
        search: "",
      },
      tablePagination: {
        page: 1,
        rowsPerPage: 10,
      },
      pageSizes: ["5", "10", "15", "20", "30", "50", "100", "Todos"],
    };
  },
};
</script>

<style></style>
